import React from 'react';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {iconName} from '@packages/systems/wfdl-Qualified';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';
const basicPlugin = Plugins.name('Basic');

const Strong = Atom.createRender(
  ({attributes, classes, generateAttributes, data, innerHTML, renderChild}) => {
    return (
      <strong {...generateAttributes(attributes, classes)}>
        {/* @ts-expect-error - TS2322 - innerHTML union includes non-ReactNode array types (TODO platform: fix innerHTML type issues) */}
        {innerHTML || getChildren(data).map((child) => renderChild(child))}
      </strong>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Bold Text',
  icon: {type: 'Component', value: [basicPlugin, iconName('Strong')]},
  showEmpty: true,
  render: Strong,
  fields: {children: TListOfElement},
});

export default config;
